import { render, staticRenderFns } from "./TaskFormDialog.vue?vue&type=template&id=05f18c6c"
import script from "./TaskFormDialog.vue?vue&type=script&lang=js"
export * from "./TaskFormDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskFormDialog.vue?vue&type=style&index=0&id=05f18c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports